"use client";

import { useEffect } from "react";
import { trackVehicleView } from "@/lib/analytics";

interface VehiclePageTrackerProps {
  vehicleName: string;
  vehicleSlug: string;
}

export default function VehiclePageTracker({ vehicleName, vehicleSlug }: VehiclePageTrackerProps) {
  useEffect(() => {
    trackVehicleView(vehicleName, vehicleSlug);
  }, [vehicleName, vehicleSlug]);

  return null;
}
